import * as React from 'react';

function SvgPercent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 22" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M10.08 6.33C10.08 10.81 7.75 13 5 13s-5-2.1-5-6.34S2.3 0 5.19 0s4.89 2.32 4.89 6.33zm-7.82.2c-.06 2.71 1 4.76 2.8 4.76s2.75-2 2.75-4.79c0-2.61-.75-4.74-2.79-4.74-1.77 0-2.76 2.13-2.76 4.77zM4.76 22L17.33 0h1.84L6.6 22zM24 15.15c0 4.47-2.33 6.69-5.09 6.69s-5-2.12-5-6.4 2.3-6.63 5.19-6.63S24 11.1 24 15.15zm-7.81.19c-.07 2.71 1 4.77 2.79 4.77s2.75-2 2.75-4.83c0-2.58-.75-4.74-2.79-4.74-1.77 0-2.75 2.13-2.75 4.8z" />
    </svg>
  );
}

const MemoSvgPercent = React.memo(SvgPercent);
export default MemoSvgPercent;
